// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 736 ? "vendor" : chunkId) + ".bundle.js?" + {"449":"eb1bc43568514196bf86","531":"1b4e924619250b9b74b7","736":"2f0366ce15d4b48be0d2"}[chunkId] + "";
};